import  { useState,  useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNewStatusFetch,
} from "../../features/action/fetchStatus";

import { OrderHeader } from "../common/OrderHeader";
import { useSearch } from "../../context/SearchContext";
import { Button, search, sortDate, sortDateDesinger } from "../../util/main";
import { Disigner } from "./Disigner";
import { ready } from "../../util/icon";
import { checkIsName } from "../../features/redux/authSlice";


const DesignerPage = () => {
  const { manager } = useSelector((state) => state.status);
  const isName = useSelector(checkIsName);

  const [filteredStatus, setFilteredStatus] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "fromDate",
    isAscending: false,
  });
  const { searchQuery } = useSearch();
  const dispatch = useDispatch();

  const designerName = (() => {
    switch (isName.username) {
      case "Irina":
        return "ira";
      case "Ofek":
        return "ofek";
      case "nati":
        return "nati";
      case "ruti":
        return "ruti";
      default:
        return null;
    }
  })();

  // Сортировка по дате завершения
  const handleToDate = (manualAscending) => {
    const isAscending =
      typeof manualAscending === "boolean"
        ? manualAscending
        : sortConfig.key === "toDate"
        ? !sortConfig.isAscending
        : false;
    setSortConfig({ key: "toDate", isAscending });
  };

  // Сортировка по дате начала
  const handleFromDate = (manualAscending) => {
    const isAscending =
      typeof manualAscending === "boolean"
        ? manualAscending
        : sortConfig.key === "fromDate"
        ? !sortConfig.isAscending
        : false;
    setSortConfig({ key: "fromDate", isAscending });
  };

  useEffect(() => {
    dispatch(getNewStatusFetch());
  }, [dispatch]);

  useEffect(() => {
    let filteredResults = searchQuery ? search(manager, searchQuery) : manager;

    if (sortConfig.key) {
      filteredResults = sortDateDesinger(
        [...filteredResults],
        sortConfig.key,
        sortConfig.isAscending
      );
    }

    setFilteredStatus(filteredResults);
  }, [searchQuery, manager, sortConfig]);

  return (
    <div className="w-[100%]">
      <div className="flex flex-col  mx-auto">
        {/* Заголовки */}
        <OrderHeader
          onFromDateClick={handleFromDate}
          onToDateClick={handleToDate}
          sortConfig={sortConfig}
        />
        <div className="rounded-xl mb-6">
          {filteredStatus.map((i) => i.designer === designerName &&(
            <div
              key={i._id}
              className="flex flex-row h-[64px] mb-1 text-center rounded-[10px] bg-white border-solid border-[1px] border-[#dbdbdb]"
            >
              ----------------------------------------Block Number Order-----------------------------------------------------
               <Disigner i={i} isName={isName}/>
              {/* ---------------------------------------Button End-------------------------------------------------- */}
              {Button(ready)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DesignerPage;
